import { StateUtils } from '@spartacus/core';
import { LoaderError } from '../../../model';

export function loaderErrorDetailsSelector<T>(state: StateUtils.LoaderState<T>): LoaderError | undefined {
  return state.errorDetails;
}
